<div class="bg-green-300 text-center p-2">
  <span class="mr-4"
    >Welcome to <span class="font-bold">Prefund Demo</span>. You can play
    around or
    <span class="underline cursor-pointer" (click)="learnMore()"
      >learn more</span
    >.
  </span>
</div>
